// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  box-shadow: none;
  background: #222222;
}

.venue_info_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
}

.lang-icon {
  height: 18px;
  width: 18px;
  border: 1.5px solid white;
  border-radius: 50%;
}

.logo-wrapper {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100vw;
}

.logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 36px;
  width: 86px;
}

.right-slot {
  display: flex;
  align-items: center;
}
.right-slot .table-chip {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background: #fff;
  height: 26px;
  padding-inline: 9px;
  margin-right: 14px;
}
.right-slot .table-chip-text {
  font-family: AppFontBold;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 0.02em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #000;
  margin-right: 6px;
}
.right-slot .table-chip-number {
  font-family: Title;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #222222;
}

.main_row {
  height: 100%;
}
.main_row .category_col {
  background: #f3f3f3;
}
.main_row .category_col .category_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 5px 10px 10px;
  margin-top: 1.5px;
  background: #f3f3f3;
  border-radius: 0px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1.5px solid rgba(79, 97, 79, 0.1019607843);
}
.main_row .category_col .category_item ion-img {
  width: 60px;
  margin-right: 10px;
}
.main_row .category_col .category_item h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  color: var(--ion-color-secondary);
}
.main_row .category_col .category_item:first-of-type {
  margin-top: 0px;
}
.main_row .category_col .category_item.selected {
  background: var(--ion-color-primary);
  color: #fff;
}
.main_row .category_col .category_item.selected h3 {
  color: white;
}
.main_row .border_top_line {
  width: 100%;
  height: 3px;
  background: #d9d9d9;
}
.main_row .category_name {
  font-family: AppFontMedium;
  font-size: 17px;
  letter-spacing: 0em;
  text-align: left;
  padding: 30px 0px 20px 7px;
}
.main_row .item_row {
  margin: 0 15px;
}
@media (min-width: 991px) {
  .main_row .item_row {
    margin: 0 0px 0 10px;
  }
}
.main_row .catalog_col {
  position: relative;
  overflow: hidden;
  padding: 0;
}
.main_row .order-col {
  padding-top: 23px;
}

.item-col {
  margin-bottom: 0 !important;
}
@media (min-width: 991px) {
  .item-col {
    margin-bottom: 0px;
    padding: 0px 7px 13px;
  }
}

.category-row {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: 23px;
}
@media (min-width: 991px) {
  .category-row {
    justify-content: flex-start;
    padding-left: 13px;
  }
}
.category-row h2 {
  font-family: Title;
  font-size: 40px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  color: #222222;
}

.search_col {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_col ion-searchbar {
  --box-shadow: 0px 0px 42px 0px #00000012;
  --border-radius: 10px;
}
.search_col .open_filters {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
}
.search_col .open_filters ion-icon {
  zoom: 1.3;
}

.footer-btn-desktop {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  width: 40%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.footer-btn-desktop ion-button {
  width: 100%;
}

.order_list_row {
  height: 100%;
  display: flex;
}
.order_list_row app-order-content {
  width: 100%;
}

.filers_section {
  background: var(--color-background-alt);
}
@media (max-width: 992px) {
  .filers_section {
    border-bottom: 1px solid #222222;
  }
}

.main-content {
  --padding-start: 0%;
  --padding-end: 0%;
}

.main-content::part(scroll)::-webkit-scrollbar {
  display: none;
}

.main-content::part(scroll) {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.category-list {
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
  align-items: center;
  height: 53px;
}
@media (min-width: 991px) {
  .category-list {
    flex-grow: 1;
  }
  .category-list > ion-chip {
    overflow: unset;
    display: flex;
    flex-grow: 1 !important;
  }
}
.category-list::-webkit-scrollbar {
  display: none;
}
.category-list ion-chip {
  flex: 0 0 auto;
  height: 30px;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin: 0px 3px;
  --background: transparent;
  border-radius: 50px;
  border: 1px solid var(--ion-color-primary);
  transition: 200ms linear;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
@media (min-width: 991px) {
  .category-list ion-chip {
    height: 35px;
  }
  .category-list ion-chip:hover {
    --background: var(--ion-color-primary-tint);
  }
  .category-list ion-chip:hover p {
    color: white;
  }
}
.category-list ion-chip:first-child {
  margin-left: 15px;
}
.category-list ion-chip:last-child {
  margin-right: 15px;
}
.category-list ion-chip p {
  font-family: AppFontBold;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 0.08em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--ion-color-primary);
  margin: 0;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
@media (min-width: 991px) {
  .category-list ion-chip p {
    font-size: 14px;
  }
}
.category-list ion-chip ion-icon,
.category-list ion-chip ion-img {
  height: 31px;
  width: 31px;
  margin-right: 5px;
}
.category-list ion-chip.selected {
  transition: 200ms linear;
  background: var(--ion-color-primary);
}
.category-list ion-chip.selected p {
  color: white;
}
.category-list ion-chip.selected ion-icon {
  fill: var(--ion-color-primary);
}

.filters-block {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 50px;
  border-top: 1px solid #3A515E;
}
.filters-block .common-filter,
.filters-block .vegan-filter {
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.filters-block .common-filter {
  border-right: 1px solid rgba(232, 232, 224, 0.1019607843);
}
.filters-block .common-filter .filter-icon {
  height: 14px;
  width: 24px;
  margin-right: 7px;
}
.filters-block .switcher {
  position: relative;
  background: var(--ion-color-primary);
  border-radius: 50px;
  height: 23px;
  width: 63px;
  border: 1px solid #000000;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 6px;
}
.filters-block .switcher .switch-toggler {
  position: absolute;
  left: 0%;
  top: 0%;
  height: 100%;
  width: 42px;
  background-color: #e8e8df;
  border: 1px solid #000000;
  border-radius: 50px;
  transition: left 0.3s ease-in-out, background 0.3s ease-in-out;
}
.filters-block .switcher .switch-toggler.selected {
  left: 32%;
  background: var(--ion-color-primary);
}
.filters-block .filters-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: #fff;
}

.more {
  min-height: 400px !important;
  width: 100%;
}
@media (max-width: 992px) {
  .more {
    min-height: 250px !important;
    width: 100%;
  }
}

.filter-toggle {
  display: flex;
  justify-content: center;
  padding: 10px 0px;
}

.no_items {
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.max-height-100 {
  max-height: 100%;
}

.order_basket_block {
  position: absolute;
  z-index: 20;
  height: 99%;
  width: 400px;
  background: #fbfbfb;
  right: -400px;
  top: -1px;
  transition: right 0.3s;
}
.order_basket_block.open {
  right: 0;
  box-shadow: -26px 11px 79px -10px rgb(149, 149, 149);
}
.order_basket_block .order_basket_header .close_basket_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding-left: 20px;
  font-family: AppFont;
  font-size: 14px;
  letter-spacing: 0em;
  color: var(--ion-color-black);
  background: #f9f9f9;
}
.order_basket_block .order_basket_header .close_basket_img_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d9d9d9;
  padding: 0 16.5px;
  height: 55px;
  width: 55px !important;
}
.order_basket_block .order_basket_header .close_basket_img_col .close_basket_img {
  height: 14px;
  width: 14px;
}

.fixed-notification {
  pointer-events: none;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: #f2dbd9;
  color: var(--color-black);
  font-family: AppFontMedium;
  text-transform: uppercase;
  text-align: center;
  padding: 20px;
  min-height: 0px;
  height: 0px;
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}
.fixed-notification.show-item {
  opacity: 1;
  height: -moz-fit-content;
  height: fit-content;
  min-height: -moz-fit-content;
  min-height: fit-content;
}
@media (max-width: 992px) {
  .fixed-notification {
    bottom: 70px;
    font-size: 14px;
  }
}

.show-basket {
  min-width: 200px;
  position: relative;
  --border-radius: 8px;
}
.show-basket ion-icon {
  margin-right: 10px;
}
@media (max-width: 992px) {
  .show-basket {
    display: none;
  }
}
.show-basket:hover {
  --background: var(--ion-color-primary) !important;
}
.show-basket h4 {
  color: white;
  font-size: 14px;
  font-family: AppFontBold;
}

.reishauer-header {
  background: var(--bg-primary);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  justify-content: flex-end;
}
.reishauer-header .logo-wrapper .vendomat-logo {
  font-size: var(--logo-font-size);
  font-weight: var(--font-weight-regular);
  color: var(--logo-color);
  font-family: var(--font-family-primary);
  letter-spacing: -0.02em;
  cursor: pointer;
}
.reishauer-header .lang-icon {
  width: 28px;
  height: 28px;
  border-radius: var(--border-radius-sm);
  transition: all 0.2s ease;
}
.reishauer-header .lang-icon:hover {
  transform: scale(1.1);
  background: rgba(255, 255, 255, 0.1);
  padding: 2px;
}
.reishauer-header .show-basket {
  margin-right: var(--spacing-sm);
}
.reishauer-header .show-basket ion-icon {
  margin-right: var(--spacing-xs);
}
.reishauer-header .show-basket h4 {
  margin: 0;
  font-size: var(--font-size-button);
  font-weight: var(--font-weight-medium);
}
.reishauer-header .show-basket:hover {
  transform: translateY(-1px);
}

.category-list .chip {
  background: var(--bg-surface);
  color: var(--text-primary-dark);
  border: 1px solid #2d69aa;
  border-radius: var(--border-radius-pill);
  transition: all 0.2s ease;
}
.category-list .chip.selected {
  background: #2d69aa;
  color: white;
  border-color: #2d69aa;
}
.category-list .chip:hover:not(.selected) {
  background: rgba(74, 144, 226, 0.1);
  border-color: var(--button-primary);
}
.category-list .chip p {
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
  color: #fff;
}

.filters-block {
  background: rgba(45, 105, 170, 0.1411764706);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.filters-block .common-filter,
.filters-block .search-filter,
.filters-block .vegan-filter {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  border-right: 1px solid #3a515e;
  color: var(--text-primary-dark);
  transition: all 0.2s ease;
  cursor: pointer;
  width: 100%;
  height: 100%;
  justify-content: center;
}
.filters-block .common-filter:last-child,
.filters-block .search-filter:last-child,
.filters-block .vegan-filter:last-child {
  border-right: none;
}
.filters-block .common-filter.all .filters-text,
.filters-block .search-filter.all .filters-text,
.filters-block .vegan-filter.all .filters-text {
  padding: 5px 14px;
  border: 1px solid #3a515e;
  border-radius: 25px;
  display: flex;
  align-items: center;
  position: relative;
  min-width: 80px;
  justify-content: flex-end;
}
.filters-block .common-filter .filter-icon,
.filters-block .common-filter .search-icon,
.filters-block .search-filter .filter-icon,
.filters-block .search-filter .search-icon,
.filters-block .vegan-filter .filter-icon,
.filters-block .vegan-filter .search-icon {
  color: inherit;
  font-size: 16px;
}
.filters-block .common-filter .filters-text,
.filters-block .search-filter .filters-text,
.filters-block .vegan-filter .filters-text {
  font-family: BricolageGrotesque;
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-medium);
  margin: 0;
}
.filters-block .common-filter .filters-text .all-filter-icon,
.filters-block .search-filter .filters-text .all-filter-icon,
.filters-block .vegan-filter .filters-text .all-filter-icon {
  width: 33px;
  height: 33px;
  position: absolute;
  left: 0;
  top: auto;
}
.filters-block .common-filter .filters-text .all-filter-icon.active::after,
.filters-block .search-filter .filters-text .all-filter-icon.active::after,
.filters-block .vegan-filter .filters-text .all-filter-icon.active::after {
  content: url("/assets/icon/v-icon-selected.svg");
  position: absolute;
  top: 5px;
  left: 10px;
  width: 11px;
  height: 20px;
}
.filters-block .common-filter .filters-text .weekly-filter-icon,
.filters-block .search-filter .filters-text .weekly-filter-icon,
.filters-block .vegan-filter .filters-text .weekly-filter-icon {
  vertical-align: top;
  width: 16px;
  height: 16px;
}
.filters-block .common-filter .switcher,
.filters-block .search-filter .switcher,
.filters-block .vegan-filter .switcher {
  width: 32px;
  height: 18px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 9px;
  position: relative;
  transition: all 0.2s ease;
}
.filters-block .common-filter .switcher .switch-toggler,
.filters-block .search-filter .switcher .switch-toggler,
.filters-block .vegan-filter .switcher .switch-toggler {
  width: 14px;
  height: 14px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: all 0.2s ease;
}
.filters-block .common-filter .switcher .switch-toggler.selected,
.filters-block .search-filter .switcher .switch-toggler.selected,
.filters-block .vegan-filter .switcher .switch-toggler.selected {
  left: 16px;
}
.filters-block .common-filter .switcher:hover,
.filters-block .search-filter .switcher:hover,
.filters-block .vegan-filter .switcher:hover {
  background: rgba(255, 255, 255, 0.3);
}
.filters-block .common-filter.vegan-filter.active .switcher,
.filters-block .search-filter.vegan-filter.active .switcher,
.filters-block .vegan-filter.vegan-filter.active .switcher {
  background: var(--vendomat-blue-light);
}

.search-container {
  padding: 0 var(--page-padding);
  background: var(--bg-elevated);
}
.search-container .reishauer-search {
  --background: var(--bg-surface);
  --color: var(--text-primary-dark);
  --placeholder-color: var(--text-secondary-dark);
  --border-radius: var(--border-radius-md);
  --box-shadow: none;
  --border: 1px solid rgba(255, 255, 255, 0.1);
}
.search-container .reishauer-search .searchbar-input {
  font-size: var(--font-size-body);
  padding: var(--spacing-sm) var(--spacing-md);
}
.search-container .reishauer-search .searchbar-search-icon {
  color: var(--text-secondary-dark);
}
.search-container .reishauer-search .searchbar-clear-icon {
  color: var(--text-secondary-dark);
}

.main_row {
  margin: 0;
}
.main_row .catalog_col {
  padding: 0;
}
.main_row .catalog_col .main-content {
  background: #f8fafb;
  --background: #f8fafb;
  padding: var(--spacing-md);
}
@media (min-width: 991px) {
  .main_row .catalog_col .main-content {
    padding: var(--spacing-xl) var(--spacing-3xl);
    background: #f8fafb;
  }
}
@media (max-width: 768px) {
  .main_row .catalog_col .main-content {
    background: #fff;
    --background: #fff;
    padding: var(--spacing-sm);
  }
}
.main_row .catalog_col .main-content .no_items {
  text-align: center;
  color: var(--text-secondary-dark);
  padding: var(--spacing-3xl) var(--spacing-lg);
}
.main_row .catalog_col .main-content .no_items p {
  font-size: var(--font-size-h3);
  font-weight: var(--font-weight-medium);
}
.main_row .catalog_col .main-content .item_row {
  margin-bottom: 80px;
}
@media (min-width: 991px) {
  .main_row .catalog_col .main-content .item_row {
    margin-bottom: 96px;
  }
}
.main_row .catalog_col .main-content .item_row .category-row {
  margin-bottom: var(--spacing-lg);
  padding: 0;
}
@media (min-width: 991px) {
  .main_row .catalog_col .main-content .item_row .category-row {
    margin-bottom: 0;
    margin-top: 10px;
  }
}
.main_row .catalog_col .main-content .item_row .category-row h2 {
  font-family: BricolageGrotesque;
  font-size: var(--font-size-h2);
  font-weight: var(--font-weight-bold);
  margin: 0 0 var(--spacing-xl) 0;
  text-transform: capitalize;
  letter-spacing: -0.02em;
  color: #072633;
  position: relative;
  padding-bottom: 20px;
}
@media (min-width: 991px) {
  .main_row .catalog_col .main-content .item_row .category-row h2 {
    font-size: 36px;
    font-weight: 800;
    letter-spacing: -0.03em;
    margin-bottom: 48px;
    padding-bottom: 24px;
    color: #072633;
    text-shadow: 0px 1px 2px rgba(7, 38, 51, 0.04);
  }
  .main_row .catalog_col .main-content .item_row .category-row h2::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: 60px;
    background: linear-gradient(90deg, #2d69aa 0%, #4a90e2 100%);
    border-radius: 3px;
  }
}
@media (max-width: 768px) {
  .main_row .catalog_col .main-content .item_row .category-row h2 {
    font-size: var(--font-size-h3);
    color: #2c3e50;
    border-bottom: 1px solid #e0e0e0;
    padding: var(--spacing-sm) 0;
    margin-bottom: var(--spacing-sm);
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  .main_row .catalog_col .main-content .item_row .category-row h2::after {
    display: none;
  }
}
.main_row .catalog_col .main-content .item_row .item-col {
  margin-bottom: var(--spacing-md);
}
@media (min-width: 991px) {
  .main_row .catalog_col .main-content .item_row .item-col {
    margin-bottom: 32px;
  }
}
.main_row .catalog_col .main-content .item_row .item-col .item-responsive {
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
@media (min-width: 991px) {
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0px 2px 12px rgba(7, 38, 51, 0.08);
    border: 1px solid rgba(45, 105, 170, 0.08);
    padding: 28px;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    cursor: pointer;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive:hover {
    transform: translateY(-4px);
    box-shadow: 0px 12px 32px rgba(7, 38, 51, 0.12), 0px 4px 12px rgba(45, 105, 170, 0.08);
    border-color: rgba(45, 105, 170, 0.15);
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(45, 105, 170, 0.02) 0%, transparent 50%);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
    border-radius: 16px;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive:hover::after {
    opacity: 1;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row {
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .item-col {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .img-wrapper {
    width: 100%;
    height: 200px;
    border-radius: 12px;
    overflow: hidden;
    background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .img-wrapper .item-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: transform 0.3s ease;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row:hover .img-wrapper .item-image {
    transform: scale(1.05);
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .item-name {
    font-size: 20px !important;
    font-weight: 700 !important;
    color: #072633 !important;
    margin: 0 0 8px 0 !important;
    line-height: 1.3 !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .item-info {
    font-size: 14px !important;
    color: #5a6c7d !important;
    line-height: 1.5 !important;
    margin: 0 0 16px 0 !important;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .price-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: auto;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .price-row .price {
    font-size: 24px !important;
    font-weight: 700 !important;
    color: #2d69aa !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .buttons ion-button {
    --background: #2d69aa;
    --background-hover: #245489;
    --color: white;
    --border-radius: 12px;
    --padding-top: 12px;
    --padding-bottom: 12px;
    --padding-start: 24px;
    --padding-end: 24px;
    font-weight: 600;
    letter-spacing: 0.02em;
    box-shadow: 0px 4px 12px rgba(45, 105, 170, 0.2);
    transition: all 0.2s ease;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .buttons ion-button:hover {
    transform: translateY(-2px);
    box-shadow: 0px 8px 20px rgba(45, 105, 170, 0.3);
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .buttons ion-button:active {
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive {
    background: #ffffff;
    margin-bottom: 12px;
    overflow: hidden;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row {
    background-color: transparent !important;
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #dce8f5;
    border-radius: 0 !important;
    padding: 12px 0;
    margin: 0 !important;
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    min-height: 100px;
    gap: 16px;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row:hover {
    background: transparent !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .item-col {
    display: flex !important;
    flex-direction: row !important;
    align-items: flex-start;
    justify-content: flex-start !important;
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    gap: 16px !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .img-wrapper {
    flex-shrink: 0 !important;
    width: 107px !important;
    height: 107px !important;
    border-radius: 8px !important;
    overflow: hidden !important;
    background: #d9d9d9 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    order: 1 !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .img-wrapper .item-image {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
    border-radius: 8px !important;
    aspect-ratio: 1 !important;
    margin-bottom: 0 !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .img-wrapper .default-image {
    width: 60% !important;
    height: 60% !important;
    opacity: 0.3 !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .item-name,
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .item-info,
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .price-row {
    position: relative !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .item-name {
    order: 2 !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    color: #072633 !important;
    margin: 0 0 4px 0 !important;
    line-height: 1.2 !important;
    text-align: left !important;
    text-transform: none !important;
    max-width: none !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px;
    flex: 1 !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .item-info {
    font-family: BricolageGrotesque;
    font-size: 12px !important;
    color: #072633 !important;
    order: 3 !important;
    margin: 0 0 8px 0 !important;
    line-height: 1.3 !important;
    text-align: left !important;
    position: absolute !important;
    top: 24px !important;
    left: 125px !important;
    right: 60px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .price-row {
    order: 4;
    display: flex;
    margin: 0 !important;
    position: absolute !important;
    left: 125px;
    align-self: flex-end;
    bottom: 0;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .price-row .price {
    font-family: BricolageGrotesque;
    font-size: 14px;
    font-weight: 700;
    color: #072633;
    margin: 0 !important;
    text-align: left !important;
    text-transform: none !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .price-row .kcall,
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .price-row .tags {
    display: none !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .buttons {
    order: 5 !important;
    flex-shrink: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 0 0 auto !important;
    width: auto !important;
    align-self: flex-end;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .buttons ion-button:hover {
    --background: ##2d69aa;
    --color: white;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .buttons ion-button:hover::before {
    color: white !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row .amount-in-basket {
    display: none !important;
  }
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row h3,
  .main_row .catalog_col .main-content .item_row .item-col .item-responsive ::ng-deep .item-row p {
    text-align: left !important;
  }
}
.main_row .catalog_col .main-content .item_row .padding-80 {
  height: 80px;
  width: 100%;
}

.fixed-notification {
  position: fixed;
  bottom: var(--spacing-lg);
  left: 50%;
  transform: translateX(-50%) translateY(100px);
  background: var(--bg-success);
  color: white;
  padding: var(--spacing-sm) var(--spacing-lg);
  border-radius: var(--border-radius-pill);
  font-weight: var(--font-weight-medium);
  box-shadow: var(--shadow-lg);
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease;
  z-index: 1000;
}
.fixed-notification.show-item {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
  pointer-events: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/app/pages/menu/menu.page.reishauer.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAKA;EACC,gBAAA;EACA,mBAAA;ACJD;;ADOA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;ACJD;;ADOA;EACC,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;ACJD;;ADOA;EACC,kBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EAEA,YAAA;ACLD;;ADUA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,YAAA;EACA,WAAA;ACRD;;ADWA;EACC,aAAA;EACA,mBAAA;ACRD;ADSC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,YAAA;EACA,mBAAA;EACA,kBAAA;ACTF;ADWE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EAEA,iBAAA;ACVH;ADaE;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,cAAA;ACZH;;ADiBA;EACC,YAAA;ACdD;ADgBC;EACC,mBAAA;ACdF;ADeE;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,yDAAA;ACfH;ADgBG;EACC,WAAA;EACA,kBAAA;ACdJ;ADgBG;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;ACdJ;ADiBG;EACC,eAAA;ACfJ;ADkBG;EACC,oCAAA;EACA,WAAA;AChBJ;ADiBI;EACC,YAAA;ACfL;ADoBC;EACC,WAAA;EACA,WAAA;EACA,mBAAA;AClBF;ADoBC;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EAEA,0BAAA;ACnBF;ADsBC;EACC,cAAA;ACpBF;AC5HE;EF+ID;IAIE,oBAAA;ECnBD;AACF;ADsBC;EACC,kBAAA;EACA,gBAAA;EACA,UAAA;ACpBF;ADuBC;EACC,iBAAA;ACrBF;;ADyBA;EACC,2BAAA;ACtBD;AC7IE;EFkKF;IAGE,kBAAA;IAEA,qBAAA;ECrBA;AACF;;ADwBA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;ACrBD;AC3JE;EF2KF;IAQE,2BAAA;IACA,kBAAA;ECpBA;AACF;ADqBC;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;ACnBF;;ADuBA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;ACpBD;ADqBC;EACC,wCAAA;EACA,qBAAA;ACnBF;ADqBC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wDAAA;ACnBF;ADoBE;EACC,SAAA;AClBH;;ADuBA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;ACpBD;ADqBC;EACC,WAAA;ACnBF;;ADuBA;EACC,YAAA;EACA,aAAA;ACpBD;ADqBC;EACC,WAAA;ACnBF;;ADuBA;EACC,uCAAA;ACpBD;ACrNE;EFwOF;IAGE,gCAAA;EClBA;AACF;;ADqBA;EACC,mBAAA;EACA,iBAAA;AClBD;;ADqBA;EACC,aAAA;AClBD;;ADoBA;EACC,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;ACjBD;;ADoBA;EACC,aAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,YAAA;EAEA,mBAAA;EACA,YAAA;AClBD;ACxPE;EFkQF;IAWE,YAAA;ECjBA;EDkBA;IACC,eAAA;IACA,aAAA;IACA,uBAAA;EChBD;AACF;ADmBC;EACC,aAAA;ACjBF;ADoBC;EACC,cAAA;EACA,YAAA;EAEA,2BAAA;EAAA,sBAAA;EACA,eAAA;EAEA,yBAAA;EACA,mBAAA;EACA,0CAAA;EAEA,wBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,gBAAA;ACvBF;ACnRE;EFyRD;IAoBE,YAAA;ECtBD;EDuBC;IACC,2CAAA;ECrBF;EDsBE;IACC,YAAA;ECpBH;AACF;ADwBE;EACC,iBAAA;ACtBH;ADyBE;EACC,kBAAA;ACvBH;AD0BE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EAEA,SAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;ACzBH;ACtTE;EF8TA;IAoBE,eAAA;ECxBF;AACF;AD0BE;;EAEC,YAAA;EACA,WAAA;EACA,iBAAA;ACxBH;AD2BE;EACC,wBAAA;EACA,oCAAA;ACzBH;AD0BG;EACC,YAAA;ACxBJ;AD2BG;EACC,8BAAA;ACzBJ;;AD+BA;EACC,aAAA;EAEA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;AC7BD;AD+BC;;EAEC,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AC7BF;ADgCC;EACC,yDAAA;AC9BF;ADgCE;EACC,YAAA;EACA,WAAA;EACA,iBAAA;AC9BH;ADkCC;EACC,kBAAA;EACA,oCAAA;EACA,mBAAA;EAEA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EAEA,iBAAA;AClCF;ADoCE;EACC,kBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EAEA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8DAAA;ACnCH;ADqCG;EACC,SAAA;EACA,oCAAA;ACnCJ;ADwCC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,WAAA;ACtCF;;AD0CA;EACC,4BAAA;EACA,WAAA;ACvCD;ACtYE;EF2aF;IAIE,4BAAA;IACA,WAAA;ECrCA;AACF;;ADwCA;EACC,aAAA;EACA,uBAAA;EACA,iBAAA;ACrCD;;ADuCA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACpCD;;ADuCA;EACC,gBAAA;ACpCD;;ADuCA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EAEA,YA9c0B;EA+c1B,mBAAA;EAGA,aAAA;EACA,SAAA;EAEA,sBAAA;ACxCD;AD0CC;EACC,QAAA;EAGA,oDAAA;ACxCF;AD4CE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AC3CH;AD8CE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AC5CH;AD6CG;EACC,YAAA;EACA,WAAA;AC3CJ;;ADgDA;EACC,oBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;AC7CD;AD+CC;EACC,UAAA;EACA,wBAAA;EAAA,mBAAA;EACA,4BAAA;EAAA,uBAAA;AC7CF;AC/dE;EFwfF;IAuBE,YAAA;IACA,eAAA;EC5CA;AACF;;AD+CA;EACC,gBAAA;EACA,kBAAA;EACA,oBAAA;AC5CD;AD8CC;EACC,kBAAA;AC5CF;AC9eE;EFohBF;IASE,aAAA;EC3CA;AACF;AD4CC;EACC,iDAAA;AC1CF;AD4CC;EACC,YAAA;EACA,eAAA;EACA,wBAAA;AC1CF;;AA3fA;EACC,6BAAA;EACA,iDAAA;EACA,yBAAA;AA8fD;AA5fE;EACC,gCAAA;EACA,uCAAA;EACA,wBAAA;EACA,uCAAA;EACA,uBAAA;EACA,eAAA;AA8fH;AA1fC;EACC,WAAA;EACA,YAAA;EACA,sCAAA;EACA,yBAAA;AA4fF;AA1fE;EACC,qBAAA;EACA,oCAAA;EACA,YAAA;AA4fH;AAxfC;EAKC,+BAAA;AAsfF;AApfE;EACC,+BAAA;AAsfH;AAnfE;EACC,SAAA;EACA,kCAAA;EACA,sCAAA;AAqfH;AAlfE;EAEC,2BAAA;AAmfH;;AA5eC;EACC,6BAAA;EACA,+BAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;AA+eF;AA7eE;EACC,mBAAA;EACA,YAAA;EACA,qBAAA;AA+eH;AA5eE;EACC,mCAAA;EACA,mCAAA;AA8eH;AA3eE;EACC,mCAAA;EACA,sCAAA;EACA,yBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AA6eH;;AAteA;EAEC,4CAAA;EACA,iDAAA;AAweD;AAreC;;;EAGC,aAAA;EACA,mBAAA;EACA,sBAAA;EAEA,+BAAA;EAEA,+BAAA;EACA,yBAAA;EAEA,eAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AAoeF;AAleE;;;EACC,kBAAA;AAseH;AA3dG;;;EACC,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AA+dJ;AA3dE;;;;;;EAEC,cAAA;EACA,eAAA;AAieH;AA9dE;;;EACC,+BAAA;EACA,mCAAA;EACA,sCAAA;EAEA,SAAA;AAieH;AAheG;;;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AAoeJ;AAjeK;;;EACC,gDAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAqeN;AAjeG;;;EACC,mBAAA;EACA,WAAA;EACA,YAAA;AAqeJ;AAheE;;;EACC,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAoeH;AAleG;;;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;AAseJ;AApeI;;;EACC,UAAA;AAweL;AApeG;;;EACC,oCAAA;AAweJ;AApeE;;;EACC,sCAAA;AAweH;;AAleA;EACC,8BAAA;EACA,8BAAA;AAqeD;AAneC;EACC,+BAAA;EACA,iCAAA;EACA,+CAAA;EACA,wCAAA;EACA,kBAAA;EACA,4CAAA;AAqeF;AAneE;EACC,gCAAA;EACA,4CAAA;AAqeH;AAleE;EACC,iCAAA;AAoeH;AAjeE;EACC,iCAAA;AAmeH;;AA7dA;EACC,SAAA;AAgeD;AA9dC;EACC,UAAA;AAgeF;AA9dE;EACC,mBAAA;EACA,qBAAA;EACA,0BAAA;AAgeH;ACxtBE;EDqPA;IAOE,6CAAA;IACA,mBAAA;EAgeF;AACF;AA7dG;EAZD;IAaE,gBAAA;IACA,kBAAA;IACA,0BAAA;EAgeF;AACF;AA9dG;EACC,kBAAA;EACA,iCAAA;EACA,6CAAA;AAgeJ;AA9dI;EACC,8BAAA;EACA,sCAAA;AAgeL;AA5dG;EACC,mBAAA;AA8dJ;ACjvBE;EDkRC;IAKE,mBAAA;EA8dH;AACF;AA5dI;EACC,gCAAA;EACA,UAAA;AA8dL;AC1vBE;ED0RE;IAME,gBAAA;IACA,gBAAA;EA8dJ;AACF;AA5dK;EACC,+BAAA;EACA,8BAAA;EACA,oCAAA;EACA,+BAAA;EACA,0BAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;AA8dN;AC3wBE;EDoSG;IAaE,eAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,oBAAA;IACA,cAAA;IAeA,8CAAA;EAgdL;EA5dK;IACC,WAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;IACA,4DAAA;IACA,kBAAA;EA8dN;AACF;AAvdM;EArCD;IAsCE,8BAAA;IACA,cAAA;IACA,gCAAA;IACA,4BAAA;IACA,gCAAA;IACA,yBAAA;IACA,sBAAA;EA0dL;EAxdK;IACC,aAAA;EA0dN;AACF;AArdI;EACC,gCAAA;AAudL;ACjzBE;EDyVE;IAKE,mBAAA;EAudJ;AACF;AArdK;EACC,gBAAA;EACA,iDAAA;AAudN;AC1zBE;EDiWG;IAME,mBAAA;IACA,mBAAA;IACA,8CAAA;IACA,0CAAA;IACA,aAAA;IACA,kBAAA;IACA,YAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;EAudL;EArdK;IACC,2BAAA;IACA,sFAAA;IACA,sCAAA;EAudN;EAndK;IACC,WAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,iFAAA;IACA,UAAA;IACA,6BAAA;IACA,oBAAA;IACA,mBAAA;EAqdN;EAldK;IACC,UAAA;EAodN;EA/cM;IACC,kCAAA;IACA,uBAAA;IACA,qBAAA;IACA,YAAA;IACA,aAAA;IACA,sBAAA;EAidP;EA/cO;IACC,aAAA;IACA,sBAAA;IACA,SAAA;IACA,OAAA;EAidR;EA9cO;IACC,WAAA;IACA,aAAA;IACA,mBAAA;IACA,gBAAA;IACA,6DAAA;EAgdR;EA9cQ;IACC,WAAA;IACA,YAAA;IACA,mBAAA;IACA,+BAAA;EAgdT;EA5cO;IACC,sBAAA;EA8cR;EA3cO;IACC,0BAAA;IACA,2BAAA;IACA,yBAAA;IACA,4BAAA;IACA,2BAAA;EA6cR;EA1cO;IACC,0BAAA;IACA,yBAAA;IACA,2BAAA;IACA,6BAAA;IACA,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;EA4cR;EAzcO;IACC,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,gBAAA;EA2cR;EAzcQ;IACC,0BAAA;IACA,2BAAA;IACA,yBAAA;EA2cT;EAtcQ;IACC,qBAAA;IACA,2BAAA;IACA,cAAA;IACA,qBAAA;IACA,mBAAA;IACA,sBAAA;IACA,qBAAA;IACA,mBAAA;IACA,gBAAA;IACA,sBAAA;IACA,gDAAA;IACA,yBAAA;EAwcT;EAtcS;IACC,2BAAA;IACA,gDAAA;EAwcV;EArcS;IACC,wBAAA;EAucV;AACF;AA/bM;EA5ID;IA6IE,mBAAA;IAEA,mBAAA;IAEA,gBAAA;EAgcL;EA5bM;IACC,wCAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;IACA,gCAAA;IACA,2BAAA;IACA,eAAA;IACA,oBAAA;IACA,wBAAA;IACA,8BAAA;IACA,8BAAA;IACA,iBAAA;IACA,SAAA;EA8bP;EA5bO;IAEC,kCAAA;EA6bR;EA1bO;IACC,wBAAA;IACA,8BAAA;IAEA,uBAAA;IACA,sCAAA;IACA,sBAAA;IACA,qBAAA;IACA,oBAAA;IACA,oBAAA;EA2bR;EAvbO;IACC,yBAAA;IACA,uBAAA;IACA,wBAAA;IACA,6BAAA;IACA,2BAAA;IACA,8BAAA;IACA,wBAAA;IACA,8BAAA;IACA,kCAAA;IACA,mBAAA;EAybR;EAvbQ;IACC,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,6BAAA;IACA,0BAAA;IACA,2BAAA;EAybT;EAtbQ;IACC,qBAAA;IACA,sBAAA;IACA,uBAAA;EAwbT;EAnbO;;;IAGC,6BAAA;EAqbR;EAlbO;IACC,mBAAA;IACA,0BAAA;IACA,2BAAA;IACA,yBAAA;IACA,4BAAA;IACA,2BAAA;IACA,2BAAA;IACA,+BAAA;IACA,0BAAA;IACA,wBAAA;IACA,8BAAA;IACA,QAAA;IACA,kBAAA;EAobR;EAtaO;IACC,+BAAA;IACA,0BAAA;IACA,yBAAA;IACA,mBAAA;IACA,4BAAA;IACA,2BAAA;IACA,2BAAA;IACA,6BAAA;IACA,oBAAA;IACA,sBAAA;IACA,sBAAA;IACA,2BAAA;IACA,kCAAA;IACA,8BAAA;EAwaR;EAraO;IACC,QAAA;IACA,aAAA;IACA,oBAAA;IACA,6BAAA;IACA,WAAA;IACA,oBAAA;IACA,SAAA;EAuaR;EAraQ;IACC,+BAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;IACA,oBAAA;IACA,2BAAA;IACA,+BAAA;EAuaT;EApaQ;;IAEC,wBAAA;EAsaT;EAjaO;IACC,mBAAA;IACA,yBAAA;IACA,wBAAA;IACA,8BAAA;IACA,kCAAA;IACA,6BAAA;IACA,sBAAA;IACA,oBAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;EAmaR;EAlXS;IAEC,sBAAA;IAEA,cAAA;EAkXV;EAhXU;IACC,uBAAA;EAkXX;EA3WO;IACC,wBAAA;EA6WR;EAzWO;;IAEC,2BAAA;EA2WR;AACF;AApWI;EACC,YAAA;EACA,WAAA;AAsWL;;AA9VA;EACC,eAAA;EACA,yBAAA;EACA,SAAA;EACA,6CAAA;EACA,6BAAA;EACA,YAAA;EACA,4CAAA;EACA,wCAAA;EACA,sCAAA;EACA,4BAAA;EACA,UAAA;EACA,oBAAA;EACA,yBAAA;EACA,aAAA;AAiWD;AA/VC;EACC,UAAA;EACA,yCAAA;EACA,oBAAA;AAiWF","sourcesContent":["@import '../../../theme/mixins';\n\n$container_padding_top: 30px;\n$order_basket_block_width: 400px;\n\nion-header {\n\tbox-shadow: none;\n\tbackground: #222222;\n}\n\n.venue_info_block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 15px;\n}\n\n.lang-icon {\n\theight: 18px;\n\twidth: 18px;\n\tborder: 1.5px solid white;\n\tborder-radius: 50%;\n}\n\n.logo-wrapper {\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\n\twidth: 100vw;\n\t// position: absolute;\n\t// left: 0;\n\t// right: 0;\n}\n.logo {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\n\theight: 36px;\n\twidth: 86px;\n}\n\n.right-slot {\n\tdisplay: flex;\n\talign-items: center;\n\t.table-chip {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tborder-radius: 6px;\n\t\tbackground: #fff;\n\n\t\theight: 26px;\n\t\tpadding-inline: 9px;\n\t\tmargin-right: 14px;\n\n\t\t&-text {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 10px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: #000;\n\n\t\t\tmargin-right: 6px;\n\t\t}\n\n\t\t&-number {\n\t\t\tfont-family: Title;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 25px;\n\t\t\tletter-spacing: 0%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\n\t\t\tcolor: #222222;\n\t\t}\n\t}\n}\n\n.main_row {\n\theight: 100%;\n\n\t.category_col {\n\t\tbackground: #f3f3f3;\n\t\t.category_item {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-start;\n\t\t\talign-items: center;\n\t\t\tpadding: 10px 5px 10px 10px;\n\t\t\tmargin-top: 1.5px;\n\n\t\t\tbackground: #f3f3f3;\n\t\t\tborder-radius: 0px;\n\n\t\t\ttransition: all 0.3s;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-start;\n\t\t\tborder-bottom: 1.5px solid #4f614f1a;\n\t\t\tion-img {\n\t\t\t\twidth: 60px;\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t\th3 {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t}\n\n\t\t\t&:first-of-type {\n\t\t\t\tmargin-top: 0px;\n\t\t\t}\n\n\t\t\t&.selected {\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\tcolor: #fff;\n\t\t\t\th3 {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.border_top_line {\n\t\twidth: 100%;\n\t\theight: 3px;\n\t\tbackground: #d9d9d9;\n\t}\n\t.category_name {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 17px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\n\t\tpadding: 30px 0px 20px 7px;\n\t}\n\n\t.item_row {\n\t\tmargin: 0 15px;\n\n\t\t@include desktop {\n\t\t\tmargin: 0 0px 0 10px;\n\t\t}\n\t}\n\n\t.catalog_col {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tpadding: 0;\n\t}\n\n\t.order-col {\n\t\tpadding-top: 23px;\n\t}\n}\n\n.item-col {\n\tmargin-bottom: 0 !important;\n\t@include desktop {\n\t\tmargin-bottom: 0px;\n\t\t// padding-inline: 13px;\n\t\tpadding: 0px 7px 13px;\n\t}\n}\n\n.category-row {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding-block: 23px;\n\n\t@include desktop {\n\t\tjustify-content: flex-start;\n\t\tpadding-left: 13px;\n\t}\n\th2 {\n\t\tfont-family: Title;\n\t\tfont-size: 40px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tcolor: #222222;\n\t}\n}\n\n.search_col {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tion-searchbar {\n\t\t--box-shadow: 0px 0px 42px 0px #00000012;\n\t\t--border-radius: 10px;\n\t}\n\t.open_filters {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 42px;\n\t\theight: 42px;\n\t\tborder-radius: 10px;\n\t\tbox-shadow: 0px 0px 42px 0px #00000012;\n\t\tion-icon {\n\t\t\tzoom: 1.3;\n\t\t}\n\t}\n}\n\n.footer-btn-desktop {\n\tposition: absolute;\n\tbottom: 35px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\twidth: 40%;\n\ttext-align: center;\n\tdisplay: flex;\n\tjustify-content: center;\n\tion-button {\n\t\twidth: 100%;\n\t}\n}\n\n.order_list_row {\n\theight: 100%;\n\tdisplay: flex;\n\tapp-order-content {\n\t\twidth: 100%;\n\t}\n}\n\n.filers_section {\n\tbackground: var(--color-background-alt);\n\t@include mobile {\n\t\tborder-bottom: 1px solid #222222;\n\t}\n}\n\n.main-content {\n\t--padding-start: 0%;\n\t--padding-end: 0%;\n}\n\n.main-content::part(scroll)::-webkit-scrollbar {\n\tdisplay: none;\n}\n.main-content::part(scroll) {\n\t-ms-overflow-style: none; /* IE and Edge */\n\tscrollbar-width: none; /* Firefox */\n}\n\n.category-list {\n\tdisplay: flex;\n\toverflow: auto;\n\tscroll-behavior: smooth;\n\t-ms-overflow-style: none;\n\tscrollbar-width: none; /* Firefox */\n\t// padding-bottom: 18px;\n\talign-items: center;\n\theight: 53px;\n\n\t@include desktop {\n\t\tflex-grow: 1;\n\t\t> ion-chip {\n\t\t\toverflow: unset;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow: 1 !important;\n\t\t}\n\t}\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\tion-chip {\n\t\tflex: 0 0 auto;\n\t\theight: 30px;\n\n\t\tmax-width: fit-content;\n\t\tmargin: 0px 3px;\n\n\t\t--background: transparent;\n\t\tborder-radius: 50px;\n\t\tborder: 1px solid var(--ion-color-primary);\n\n\t\ttransition: 200ms linear;\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\toverflow: hidden;\n\n\t\t@include desktop {\n\t\t\theight: 35px;\n\t\t\t&:hover {\n\t\t\t\t--background: var(--ion-color-primary-tint);\n\t\t\t\tp {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&:first-child {\n\t\t\tmargin-left: 15px;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-right: 15px;\n\t\t}\n\n\t\tp {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 10px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 0.08em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--ion-color-primary);\n\n\t\t\tmargin: 0;\n\t\t\tword-break: break-word;\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 1;\n\t\t\t-webkit-box-orient: vertical;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\ttext-align: center;\n\n\t\t\t@include desktop {\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t}\n\t\tion-icon,\n\t\tion-img {\n\t\t\theight: 31px;\n\t\t\twidth: 31px;\n\t\t\tmargin-right: 5px;\n\t\t}\n\n\t\t&.selected {\n\t\t\ttransition: 200ms linear;\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tp {\n\t\t\t\tcolor: white;\n\t\t\t}\n\n\t\t\tion-icon {\n\t\t\t\tfill: var(--ion-color-primary);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.filters-block {\n\tdisplay: flex;\n\t// justify-content: space-between;\n\tjustify-content: flex-start;\n\talign-items: center;\n\theight: 50px;\n\tborder-top: 1px solid #3A515E;\n\n\t.common-filter,\n\t.vegan-filter {\n\t\theight: 100%;\n\t\twidth: 50%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t.common-filter {\n\t\tborder-right: 1px solid #e8e8e01a;\n\n\t\t.filter-icon {\n\t\t\theight: 14px;\n\t\t\twidth: 24px;\n\t\t\tmargin-right: 7px;\n\t\t}\n\t}\n\n\t.switcher {\n\t\tposition: relative;\n\t\tbackground: var(--ion-color-primary);\n\t\tborder-radius: 50px;\n\n\t\theight: 23px;\n\t\twidth: 63px;\n\t\tborder: 1px solid #000000;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\n\t\tmargin-right: 6px;\n\n\t\t.switch-toggler {\n\t\t\tposition: absolute;\n\t\t\tleft: 0%;\n\t\t\ttop: 0%;\n\t\t\theight: 100%;\n\t\t\twidth: 42px;\n\n\t\t\tbackground-color: #e8e8df;\n\t\t\tborder: 1px solid #000000;\n\t\t\tborder-radius: 50px;\n\t\t\ttransition: left 0.3s ease-in-out, background 0.3s ease-in-out;\n\n\t\t\t&.selected {\n\t\t\t\tleft: 32%;\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t}\n\t\t}\n\t}\n\n\t.filters-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\tvertical-align: middle;\n\t\ttext-transform: capitalize;\n\t\tcolor: #fff;\n\t}\n}\n\n.more {\n\tmin-height: 400px !important;\n\twidth: 100%;\n\t@include mobile {\n\t\tmin-height: 250px !important;\n\t\twidth: 100%;\n\t}\n}\n\n.filter-toggle {\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 10px 0px;\n}\n.no_items {\n\twidth: 100%;\n\theight: 70vh;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.max-height-100 {\n\tmax-height: 100%;\n}\n\n.order_basket_block {\n\tposition: absolute;\n\tz-index: 20;\n\theight: 99%;\n\n\twidth: $order_basket_block_width;\n\tbackground: #fbfbfb;\n\t// box-shadow: 0px 4px 4px 0px #00000040;\n\n\tright: calc($order_basket_block_width * (-1));\n\ttop: -1px;\n\n\ttransition: right 0.3s;\n\n\t&.open {\n\t\tright: 0;\n\t\t-webkit-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t\t-moz-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t\tbox-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t}\n\n\t.order_basket_header {\n\t\t.close_basket_col {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tbackground: transparent;\n\t\t\tpadding-left: 20px;\n\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 14px;\n\t\t\tletter-spacing: 0em;\n\t\t\tcolor: var(--ion-color-black);\n\t\t\tbackground: #f9f9f9;\n\t\t}\n\n\t\t.close_basket_img_col {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tbackground: #d9d9d9;\n\t\t\tpadding: 0 16.5px;\n\t\t\theight: 55px;\n\t\t\twidth: 55px !important;\n\t\t\t.close_basket_img {\n\t\t\t\theight: 14px;\n\t\t\t\twidth: 14px;\n\t\t\t}\n\t\t}\n\t}\n}\n.fixed-notification {\n\tpointer-events: none;\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\tbackground: #f2dbd9;\n\tcolor: var(--color-black);\n\tfont-family: AppFontMedium;\n\ttext-transform: uppercase;\n\ttext-align: center;\n\tpadding: 20px;\n\tmin-height: 0px;\n\theight: 0px;\n\ttransition: opacity 0.3s ease-in-out;\n\topacity: 0;\n\n\t&.show-item {\n\t\topacity: 1;\n\t\theight: fit-content;\n\t\tmin-height: fit-content;\n\t}\n\t@include mobile {\n\t\tbottom: 70px;\n\t\tfont-size: 14px;\n\t}\n}\n\n.show-basket {\n\tmin-width: 200px;\n\tposition: relative;\n\t--border-radius: 8px;\n\t// min-height: 35px;\n\tion-icon {\n\t\tmargin-right: 10px;\n\t}\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t&:hover {\n\t\t--background: var(--ion-color-primary) !important;\n\t}\n\th4 {\n\t\tcolor: white;\n\t\tfont-size: 14px;\n\t\tfont-family: AppFontBold;\n\t}\n}\n","// Reishauer Menu Page Styles\n// Updates the menu page header with vendomat branding\n\n// Import the base menu styles\n@import './menu.page.scss';\n\n// Reishauer-specific header styling\n.reishauer-header {\n\tbackground: var(--bg-primary);\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\tjustify-content: flex-end;\n\t.logo-wrapper {\n\t\t.vendomat-logo {\n\t\t\tfont-size: var(--logo-font-size);\n\t\t\tfont-weight: var(--font-weight-regular);\n\t\t\tcolor: var(--logo-color);\n\t\t\tfont-family: var(--font-family-primary);\n\t\t\tletter-spacing: -0.02em;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\t.lang-icon {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: var(--border-radius-sm);\n\t\ttransition: all 0.2s ease;\n\n\t\t&:hover {\n\t\t\ttransform: scale(1.1);\n\t\t\tbackground: rgba(255, 255, 255, 0.1);\n\t\t\tpadding: 2px;\n\t\t}\n\t}\n\n\t.show-basket {\n\t\t// background: var(--button-primary);\n\t\t// color: white;\n\t\t// border-radius: var(--border-radius-md);\n\t\t// padding: var(--spacing-sm) var(--spacing-md);\n\t\tmargin-right: var(--spacing-sm);\n\n\t\tion-icon {\n\t\t\tmargin-right: var(--spacing-xs);\n\t\t}\n\n\t\th4 {\n\t\t\tmargin: 0;\n\t\t\tfont-size: var(--font-size-button);\n\t\t\tfont-weight: var(--font-weight-medium);\n\t\t}\n\n\t\t&:hover {\n\t\t\t// background: var(--vendomat-blue-dark);\n\t\t\ttransform: translateY(-1px);\n\t\t}\n\t}\n}\n\n// Category chips styling\n.category-list {\n\t.chip {\n\t\tbackground: var(--bg-surface);\n\t\tcolor: var(--text-primary-dark);\n\t\tborder: 1px solid #2d69aa;\n\t\tborder-radius: var(--border-radius-pill);\n\t\ttransition: all 0.2s ease;\n\n\t\t&.selected {\n\t\t\tbackground: #2d69aa;\n\t\t\tcolor: white;\n\t\t\tborder-color: #2d69aa;\n\t\t}\n\n\t\t&:hover:not(.selected) {\n\t\t\tbackground: rgba(74, 144, 226, 0.1);\n\t\t\tborder-color: var(--button-primary);\n\t\t}\n\n\t\tp {\n\t\t\tfont-size: var(--font-size-caption);\n\t\t\tfont-weight: var(--font-weight-medium);\n\t\t\ttext-transform: uppercase;\n\t\t\tletter-spacing: 0.05em;\n\t\t\tmargin: 0;\n\t\t\tcolor: #fff;\n\t\t\t// color: #fff;\n\t\t}\n\t}\n}\n\n// Filters section styling\n.filters-block {\n\t// background: var(--bg-elevated);\n\tbackground: #2d69aa24;\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\t// padding: var(--spacing-sm) var(--page-padding);\n\n\t.common-filter,\n\t.search-filter,\n\t.vegan-filter {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: var(--spacing-xs);\n\t\t// background: var(--bg-surface);\n\t\tborder-right: 1px solid #3a515e;\n\t\t// border-radius: var(--border-radius-md);\n\t\tcolor: var(--text-primary-dark);\n\t\ttransition: all 0.2s ease;\n\t\t// padding: var(--spacing-sm) var(--spacing-md);\n\t\tcursor: pointer;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tjustify-content: center;\n\n\t\t&:last-child {\n\t\t\tborder-right: none;\n\t\t}\n\n\t\t&:hover,\n\t\t&.active {\n\t\t\t// background: var(--button-primary);\n\t\t\t// color: white;\n\t\t\t// border-color: var(--button-primary);\n\t\t}\n\n\t\t&.all {\n\t\t\t.filters-text {\n\t\t\t\tpadding: 5px 14px;\n\t\t\t\tborder: 1px solid #3a515e;\n\t\t\t\tborder-radius: 25px;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tposition: relative;\n\t\t\t\tmin-width: 80px;\n\t\t\t\tjustify-content: flex-end;\n\t\t\t}\n\t\t}\n\n\t\t.filter-icon,\n\t\t.search-icon {\n\t\t\tcolor: inherit;\n\t\t\tfont-size: 16px;\n\t\t}\n\n\t\t.filters-text {\n\t\t\tfont-family: BricolageGrotesque;\n\t\t\tfont-size: var(--font-size-caption);\n\t\t\tfont-weight: var(--font-weight-medium);\n\t\t\t// letter-spacing: 0.05em;\n\t\t\tmargin: 0;\n\t\t\t.all-filter-icon {\n\t\t\t\twidth: 33px;\n\t\t\t\theight: 33px;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 0;\n\t\t\t\ttop: auto;\n\n\t\t\t\t&.active {\n\t\t\t\t\t&::after {\n\t\t\t\t\t\tcontent: url('/assets/icon/v-icon-selected.svg');\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 5px;\n\t\t\t\t\t\tleft: 10px;\n\t\t\t\t\t\twidth: 11px;\n\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.weekly-filter-icon {\n\t\t\t\tvertical-align: top;\n\t\t\t\twidth: 16px;\n\t\t\t\theight: 16px;\n\t\t\t}\n\t\t}\n\n\t\t// Vegan filter switcher\n\t\t.switcher {\n\t\t\twidth: 32px;\n\t\t\theight: 18px;\n\t\t\tbackground: rgba(255, 255, 255, 0.2);\n\t\t\tborder-radius: 9px;\n\t\t\tposition: relative;\n\t\t\ttransition: all 0.2s ease;\n\n\t\t\t.switch-toggler {\n\t\t\t\twidth: 14px;\n\t\t\t\theight: 14px;\n\t\t\t\tbackground: white;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 2px;\n\t\t\t\tleft: 2px;\n\t\t\t\ttransition: all 0.2s ease;\n\n\t\t\t\t&.selected {\n\t\t\t\t\tleft: 16px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tbackground: rgba(255, 255, 255, 0.3);\n\t\t\t}\n\t\t}\n\n\t\t&.vegan-filter.active .switcher {\n\t\t\tbackground: var(--vendomat-blue-light);\n\t\t}\n\t}\n}\n\n// Search bar styling\n.search-container {\n\tpadding: 0 var(--page-padding);\n\tbackground: var(--bg-elevated);\n\n\t.reishauer-search {\n\t\t--background: var(--bg-surface);\n\t\t--color: var(--text-primary-dark);\n\t\t--placeholder-color: var(--text-secondary-dark);\n\t\t--border-radius: var(--border-radius-md);\n\t\t--box-shadow: none;\n\t\t--border: 1px solid rgba(255, 255, 255, 0.1);\n\n\t\t.searchbar-input {\n\t\t\tfont-size: var(--font-size-body);\n\t\t\tpadding: var(--spacing-sm) var(--spacing-md);\n\t\t}\n\n\t\t.searchbar-search-icon {\n\t\t\tcolor: var(--text-secondary-dark);\n\t\t}\n\n\t\t.searchbar-clear-icon {\n\t\t\tcolor: var(--text-secondary-dark);\n\t\t}\n\t}\n}\n\n// Main content area\n.main_row {\n\tmargin: 0;\n\n\t.catalog_col {\n\t\tpadding: 0;\n\n\t\t.main-content {\n\t\t\tbackground: #f8fafb;\n\t\t\t--background: #f8fafb;\n\t\t\tpadding: var(--spacing-md);\n\n\t\t\t// Desktop: more spacious layout\n\t\t\t@include desktop {\n\t\t\t\tpadding: var(--spacing-xl) var(--spacing-3xl);\n\t\t\t\tbackground: #f8fafb;\n\t\t\t}\n\n\t\t\t// Mobile optimization\n\t\t\t@media (max-width: 768px) {\n\t\t\t\tbackground: #fff;\n\t\t\t\t--background: #fff;\n\t\t\t\tpadding: var(--spacing-sm);\n\t\t\t}\n\n\t\t\t.no_items {\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: var(--text-secondary-dark);\n\t\t\t\tpadding: var(--spacing-3xl) var(--spacing-lg);\n\n\t\t\t\tp {\n\t\t\t\t\tfont-size: var(--font-size-h3);\n\t\t\t\t\tfont-weight: var(--font-weight-medium);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.item_row {\n\t\t\t\tmargin-bottom: 80px;\n\n\t\t\t\t// Desktop: increase spacing between categories\n\t\t\t\t@include desktop {\n\t\t\t\t\tmargin-bottom: 96px;\n\t\t\t\t}\n\n\t\t\t\t.category-row {\n\t\t\t\t\tmargin-bottom: var(--spacing-lg);\n\t\t\t\t\tpadding: 0;\n\n\t\t\t\t\t// Desktop: add extra top spacing for visual breathing room\n\t\t\t\t\t@include desktop {\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t\tmargin-top: 10px;\n\t\t\t\t\t}\n\n\t\t\t\t\th2 {\n\t\t\t\t\t\tfont-family: BricolageGrotesque;\n\t\t\t\t\t\tfont-size: var(--font-size-h2);\n\t\t\t\t\t\tfont-weight: var(--font-weight-bold);\n\t\t\t\t\t\tmargin: 0 0 var(--spacing-xl) 0;\n\t\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\t\tletter-spacing: -0.02em;\n\t\t\t\t\t\tcolor: #072633;\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tpadding-bottom: 20px;\n\n\t\t\t\t\t\t// Premium heading style for desktop\n\t\t\t\t\t\t@include desktop {\n\t\t\t\t\t\t\tfont-size: 36px;\n\t\t\t\t\t\t\tfont-weight: 800;\n\t\t\t\t\t\t\tletter-spacing: -0.03em;\n\t\t\t\t\t\t\tmargin-bottom: 48px;\n\t\t\t\t\t\t\tpadding-bottom: 24px;\n\t\t\t\t\t\t\tcolor: #072633;\n\n\t\t\t\t\t\t\t// Decorative accent line\n\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\t\theight: 3px;\n\t\t\t\t\t\t\t\twidth: 60px;\n\t\t\t\t\t\t\t\tbackground: linear-gradient(90deg, #2d69aa 0%, #4a90e2 100%);\n\t\t\t\t\t\t\t\tborder-radius: 3px;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t// Subtle text shadow for depth\n\t\t\t\t\t\t\ttext-shadow: 0px 1px 2px rgba(7, 38, 51, 0.04);\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t// Mobile category headers\n\t\t\t\t\t\t@media (max-width: 768px) {\n\t\t\t\t\t\t\tfont-size: var(--font-size-h3);\n\t\t\t\t\t\t\tcolor: #2c3e50;\n\t\t\t\t\t\t\tborder-bottom: 1px solid #e0e0e0;\n\t\t\t\t\t\t\tpadding: var(--spacing-sm) 0;\n\t\t\t\t\t\t\tmargin-bottom: var(--spacing-sm);\n\t\t\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\t\t\tletter-spacing: 0.05em;\n\n\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.item-col {\n\t\t\t\t\tmargin-bottom: var(--spacing-md);\n\n\t\t\t\t\t// Desktop: better card spacing\n\t\t\t\t\t@include desktop {\n\t\t\t\t\t\tmargin-bottom: 32px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.item-responsive {\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\ttransition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n\t\t\t\t\t\t// Desktop premium card styling\n\t\t\t\t\t\t@include desktop {\n\t\t\t\t\t\t\tbackground: #ffffff;\n\t\t\t\t\t\t\tborder-radius: 16px;\n\t\t\t\t\t\t\tbox-shadow: 0px 2px 12px rgba(7, 38, 51, 0.08);\n\t\t\t\t\t\t\tborder: 1px solid rgba(45, 105, 170, 0.08);\n\t\t\t\t\t\t\tpadding: 28px;\n\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\ttransform: translateY(-4px);\n\t\t\t\t\t\t\t\tbox-shadow: 0px 12px 32px rgba(7, 38, 51, 0.12), 0px 4px 12px rgba(45, 105, 170, 0.08);\n\t\t\t\t\t\t\t\tborder-color: rgba(45, 105, 170, 0.15);\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t// Add subtle gradient overlay on hover\n\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\tbackground: linear-gradient(135deg, rgba(45, 105, 170, 0.02) 0%, transparent 50%);\n\t\t\t\t\t\t\t\topacity: 0;\n\t\t\t\t\t\t\t\ttransition: opacity 0.3s ease;\n\t\t\t\t\t\t\t\tpointer-events: none;\n\t\t\t\t\t\t\t\tborder-radius: 16px;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t&:hover::after {\n\t\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t// Desktop item styling\n\t\t\t\t\t\t\t::ng-deep {\n\t\t\t\t\t\t\t\t.item-row {\n\t\t\t\t\t\t\t\t\tbackground: transparent !important;\n\t\t\t\t\t\t\t\t\tborder: none !important;\n\t\t\t\t\t\t\t\t\tpadding: 0 !important;\n\t\t\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\tflex-direction: column;\n\n\t\t\t\t\t\t\t\t\t.item-col {\n\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\t\t\t\t\tgap: 16px;\n\t\t\t\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t.img-wrapper {\n\t\t\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\t\t\theight: 200px;\n\t\t\t\t\t\t\t\t\t\tborder-radius: 12px;\n\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\tbackground: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);\n\n\t\t\t\t\t\t\t\t\t\t.item-image {\n\t\t\t\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\t\t\t\t\tobject-fit: contain;\n\t\t\t\t\t\t\t\t\t\t\ttransition: transform 0.3s ease;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t&:hover .img-wrapper .item-image {\n\t\t\t\t\t\t\t\t\t\ttransform: scale(1.05);\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t.item-name {\n\t\t\t\t\t\t\t\t\t\tfont-size: 20px !important;\n\t\t\t\t\t\t\t\t\t\tfont-weight: 700 !important;\n\t\t\t\t\t\t\t\t\t\tcolor: #072633 !important;\n\t\t\t\t\t\t\t\t\t\tmargin: 0 0 8px 0 !important;\n\t\t\t\t\t\t\t\t\t\tline-height: 1.3 !important;\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t.item-info {\n\t\t\t\t\t\t\t\t\t\tfont-size: 14px !important;\n\t\t\t\t\t\t\t\t\t\tcolor: #5a6c7d !important;\n\t\t\t\t\t\t\t\t\t\tline-height: 1.5 !important;\n\t\t\t\t\t\t\t\t\t\tmargin: 0 0 16px 0 !important;\n\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t\t\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t.price-row {\n\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\t\t\t\t\tmargin-top: auto;\n\n\t\t\t\t\t\t\t\t\t\t.price {\n\t\t\t\t\t\t\t\t\t\t\tfont-size: 24px !important;\n\t\t\t\t\t\t\t\t\t\t\tfont-weight: 700 !important;\n\t\t\t\t\t\t\t\t\t\t\tcolor: #2d69aa !important;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t.buttons {\n\t\t\t\t\t\t\t\t\t\tion-button {\n\t\t\t\t\t\t\t\t\t\t\t--background: #2d69aa;\n\t\t\t\t\t\t\t\t\t\t\t--background-hover: #245489;\n\t\t\t\t\t\t\t\t\t\t\t--color: white;\n\t\t\t\t\t\t\t\t\t\t\t--border-radius: 12px;\n\t\t\t\t\t\t\t\t\t\t\t--padding-top: 12px;\n\t\t\t\t\t\t\t\t\t\t\t--padding-bottom: 12px;\n\t\t\t\t\t\t\t\t\t\t\t--padding-start: 24px;\n\t\t\t\t\t\t\t\t\t\t\t--padding-end: 24px;\n\t\t\t\t\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t\t\t\t\t\tletter-spacing: 0.02em;\n\t\t\t\t\t\t\t\t\t\t\tbox-shadow: 0px 4px 12px rgba(45, 105, 170, 0.2);\n\t\t\t\t\t\t\t\t\t\t\ttransition: all 0.2s ease;\n\n\t\t\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t\t\ttransform: translateY(-2px);\n\t\t\t\t\t\t\t\t\t\t\t\tbox-shadow: 0px 8px 20px rgba(45, 105, 170, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t&:active {\n\t\t\t\t\t\t\t\t\t\t\t\ttransform: translateY(0);\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t// Mobile horizontal card layout (matching screenshot)\n\t\t\t\t\t\t@media (max-width: 768px) {\n\t\t\t\t\t\t\tbackground: #ffffff;\n\t\t\t\t\t\t\t// border-radius: 12px;\n\t\t\t\t\t\t\tmargin-bottom: 12px;\n\t\t\t\t\t\t\t// box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n\t\t\t\t\t\t\toverflow: hidden;\n\n\t\t\t\t\t\t\t// Override the existing item-view component structure\n\t\t\t\t\t\t\t::ng-deep {\n\t\t\t\t\t\t\t\t.item-row {\n\t\t\t\t\t\t\t\t\tbackground-color: transparent !important;\n\t\t\t\t\t\t\t\t\tborder-top: none;\n\t\t\t\t\t\t\t\t\tborder-left: none;\n\t\t\t\t\t\t\t\t\tborder-right: none;\n\t\t\t\t\t\t\t\t\tborder-bottom: 1px solid #dce8f5;\n\t\t\t\t\t\t\t\t\tborder-radius: 0 !important;\n\t\t\t\t\t\t\t\t\tpadding: 12px 0;\n\t\t\t\t\t\t\t\t\tmargin: 0 !important;\n\t\t\t\t\t\t\t\t\tdisplay: flex !important;\n\t\t\t\t\t\t\t\t\tflex-direction: row !important;\n\t\t\t\t\t\t\t\t\talign-items: center !important;\n\t\t\t\t\t\t\t\t\tmin-height: 100px;\n\t\t\t\t\t\t\t\t\tgap: 16px;\n\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t// border: none !important;\n\t\t\t\t\t\t\t\t\t\tbackground: transparent !important;\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t.item-col {\n\t\t\t\t\t\t\t\t\t\tdisplay: flex !important;\n\t\t\t\t\t\t\t\t\t\tflex-direction: row !important;\n\t\t\t\t\t\t\t\t\t\t// align-items: center !important;\n\t\t\t\t\t\t\t\t\t\talign-items: flex-start;\n\t\t\t\t\t\t\t\t\t\tjustify-content: flex-start !important;\n\t\t\t\t\t\t\t\t\t\twidth: 100% !important;\n\t\t\t\t\t\t\t\t\t\tpadding: 0 !important;\n\t\t\t\t\t\t\t\t\t\tmargin: 0 !important;\n\t\t\t\t\t\t\t\t\t\tgap: 16px !important;\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t// Image section - leftmost\n\t\t\t\t\t\t\t\t\t.img-wrapper {\n\t\t\t\t\t\t\t\t\t\tflex-shrink: 0 !important;\n\t\t\t\t\t\t\t\t\t\twidth: 107px !important;\n\t\t\t\t\t\t\t\t\t\theight: 107px !important;\n\t\t\t\t\t\t\t\t\t\tborder-radius: 8px !important;\n\t\t\t\t\t\t\t\t\t\toverflow: hidden !important;\n\t\t\t\t\t\t\t\t\t\tbackground: #d9d9d9 !important;\n\t\t\t\t\t\t\t\t\t\tdisplay: flex !important;\n\t\t\t\t\t\t\t\t\t\talign-items: center !important;\n\t\t\t\t\t\t\t\t\t\tjustify-content: center !important;\n\t\t\t\t\t\t\t\t\t\torder: 1 !important;\n\n\t\t\t\t\t\t\t\t\t\t.item-image {\n\t\t\t\t\t\t\t\t\t\t\twidth: 100% !important;\n\t\t\t\t\t\t\t\t\t\t\theight: 100% !important;\n\t\t\t\t\t\t\t\t\t\t\tobject-fit: contain !important;\n\t\t\t\t\t\t\t\t\t\t\tborder-radius: 8px !important;\n\t\t\t\t\t\t\t\t\t\t\taspect-ratio: 1 !important;\n\t\t\t\t\t\t\t\t\t\t\tmargin-bottom: 0 !important;\n\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t.default-image {\n\t\t\t\t\t\t\t\t\t\t\twidth: 60% !important;\n\t\t\t\t\t\t\t\t\t\t\theight: 60% !important;\n\t\t\t\t\t\t\t\t\t\t\topacity: 0.3 !important;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t// Content section - middle, create a wrapper\n\t\t\t\t\t\t\t\t\t.item-name,\n\t\t\t\t\t\t\t\t\t.item-info,\n\t\t\t\t\t\t\t\t\t.price-row {\n\t\t\t\t\t\t\t\t\t\tposition: relative !important;\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t.item-name {\n\t\t\t\t\t\t\t\t\t\torder: 2 !important;\n\t\t\t\t\t\t\t\t\t\tfont-size: 16px !important;\n\t\t\t\t\t\t\t\t\t\tfont-weight: 700 !important;\n\t\t\t\t\t\t\t\t\t\tcolor: #072633 !important;\n\t\t\t\t\t\t\t\t\t\tmargin: 0 0 4px 0 !important;\n\t\t\t\t\t\t\t\t\t\tline-height: 1.2 !important;\n\t\t\t\t\t\t\t\t\t\ttext-align: left !important;\n\t\t\t\t\t\t\t\t\t\ttext-transform: none !important;\n\t\t\t\t\t\t\t\t\t\tmax-width: none !important;\n\t\t\t\t\t\t\t\t\t\tdisplay: flex !important;\n\t\t\t\t\t\t\t\t\t\talign-items: center !important;\n\t\t\t\t\t\t\t\t\t\tgap: 8px;\n\t\t\t\t\t\t\t\t\t\tflex: 1 !important;\n\t\t\t\t\t\t\t\t\t\t// min-width: fit-content;\n\n\t\t\t\t\t\t\t\t\t\t// &::after {\n\t\t\t\t\t\t\t\t\t\t//  content: url(\"/assets/icon/info-icon.svg\");\n\t\t\t\t\t\t\t\t\t\t//  display: inline-flex;\n\t\t\t\t\t\t\t\t\t\t//  align-items: baseline;\n\t\t\t\t\t\t\t\t\t\t//  justify-content: center;\n\t\t\t\t\t\t\t\t\t\t//  width: 15px;\n\t\t\t\t\t\t\t\t\t\t//  height: 15px;\n\t\t\t\t\t\t\t\t\t\t//  cursor: pointer;\n\t\t\t\t\t\t\t\t\t\t// }\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t.item-info {\n\t\t\t\t\t\t\t\t\t\tfont-family: BricolageGrotesque;\n\t\t\t\t\t\t\t\t\t\tfont-size: 12px !important;\n\t\t\t\t\t\t\t\t\t\tcolor: #072633 !important;\n\t\t\t\t\t\t\t\t\t\torder: 3 !important;\n\t\t\t\t\t\t\t\t\t\tmargin: 0 0 8px 0 !important;\n\t\t\t\t\t\t\t\t\t\tline-height: 1.3 !important;\n\t\t\t\t\t\t\t\t\t\ttext-align: left !important;\n\t\t\t\t\t\t\t\t\t\tposition: absolute !important;\n\t\t\t\t\t\t\t\t\t\ttop: 24px !important;\n\t\t\t\t\t\t\t\t\t\tleft: 125px !important;\n\t\t\t\t\t\t\t\t\t\tright: 60px !important;\n\t\t\t\t\t\t\t\t\t\toverflow: hidden !important;\n\t\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis !important;\n\t\t\t\t\t\t\t\t\t\twhite-space: nowrap !important;\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t.price-row {\n\t\t\t\t\t\t\t\t\t\torder: 4;\n\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\tmargin: 0 !important;\n\t\t\t\t\t\t\t\t\t\tposition: absolute !important;\n\t\t\t\t\t\t\t\t\t\tleft: 125px;\n\t\t\t\t\t\t\t\t\t\talign-self: flex-end;\n\t\t\t\t\t\t\t\t\t\tbottom: 0;\n\n\t\t\t\t\t\t\t\t\t\t.price {\n\t\t\t\t\t\t\t\t\t\t\tfont-family: BricolageGrotesque;\n\t\t\t\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\t\t\t\t\t\tcolor: #072633;\n\t\t\t\t\t\t\t\t\t\t\tmargin: 0 !important;\n\t\t\t\t\t\t\t\t\t\t\ttext-align: left !important;\n\t\t\t\t\t\t\t\t\t\t\ttext-transform: none !important;\n\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t.kcall,\n\t\t\t\t\t\t\t\t\t\t.tags {\n\t\t\t\t\t\t\t\t\t\t\tdisplay: none !important;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t// Add button - rightmost\n\t\t\t\t\t\t\t\t\t.buttons {\n\t\t\t\t\t\t\t\t\t\torder: 5 !important;\n\t\t\t\t\t\t\t\t\t\tflex-shrink: 0 !important;\n\t\t\t\t\t\t\t\t\t\tdisplay: flex !important;\n\t\t\t\t\t\t\t\t\t\talign-items: center !important;\n\t\t\t\t\t\t\t\t\t\tjustify-content: center !important;\n\t\t\t\t\t\t\t\t\t\tmargin: 0 0 0 auto !important;\n\t\t\t\t\t\t\t\t\t\twidth: auto !important;\n\t\t\t\t\t\t\t\t\t\talign-self: flex-end;\n\t\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\t\t\tright: 0;\n\n\t\t\t\t\t\t\t\t\t\tion-button {\n\t\t\t\t\t\t\t\t\t\t\t// width: 32px;\n\t\t\t\t\t\t\t\t\t\t\t// height: 32px;\n\t\t\t\t\t\t\t\t\t\t\t// border-radius: 50% !important;\n\t\t\t\t\t\t\t\t\t\t\t// border: 2px solid #2D69AA !important;\n\t\t\t\t\t\t\t\t\t\t\t// background: transparent !important;\n\t\t\t\t\t\t\t\t\t\t\t// color: #2D69AA !important;\n\t\t\t\t\t\t\t\t\t\t\t// display: flex !important;\n\t\t\t\t\t\t\t\t\t\t\t// align-items: center !important;\n\t\t\t\t\t\t\t\t\t\t\t// justify-content: center !important;\n\t\t\t\t\t\t\t\t\t\t\t// margin: 0 !important;\n\t\t\t\t\t\t\t\t\t\t\t// padding: 0 !important;\n\t\t\t\t\t\t\t\t\t\t\t// min-height: 32px !important;\n\t\t\t\t\t\t\t\t\t\t\t// position: relative !important;\n\n\t\t\t\t\t\t\t\t\t\t\t// Hide the original text\n\t\t\t\t\t\t\t\t\t\t\t// font-size: 0 !important;\n\t\t\t\t\t\t\t\t\t\t\t// text-indent: -9999px !important;\n\n\t\t\t\t\t\t\t\t\t\t\t// &::before {\n\t\t\t\t\t\t\t\t\t\t\t//   content: \"+\" !important;\n\t\t\t\t\t\t\t\t\t\t\t//   position: absolute !important;\n\t\t\t\t\t\t\t\t\t\t\t//   top: 50% !important;\n\t\t\t\t\t\t\t\t\t\t\t//   left: 50% !important;\n\t\t\t\t\t\t\t\t\t\t\t//   transform: translate(-50%, -50%) !important;\n\t\t\t\t\t\t\t\t\t\t\t//   font-size: 20px !important;\n\t\t\t\t\t\t\t\t\t\t\t//   font-weight: 300 !important;\n\t\t\t\t\t\t\t\t\t\t\t//   line-height: 1 !important;\n\t\t\t\t\t\t\t\t\t\t\t//   color: #4A90E2 !important;\n\t\t\t\t\t\t\t\t\t\t\t//   z-index: 1 !important;\n\t\t\t\t\t\t\t\t\t\t\t// }\n\n\t\t\t\t\t\t\t\t\t\t\t// Hide all child elements\n\t\t\t\t\t\t\t\t\t\t\t// * {\n\t\t\t\t\t\t\t\t\t\t\t// visibility: hidden !important;\n\t\t\t\t\t\t\t\t\t\t\t// }\n\n\t\t\t\t\t\t\t\t\t\t\t// &.transparent {\n\t\t\t\t\t\t\t\t\t\t\t//   --background: transparent !important;\n\t\t\t\t\t\t\t\t\t\t\t//   --color: #4A90E2 !important;\n\t\t\t\t\t\t\t\t\t\t\t//   --border-color: #4A90E2 !important;\n\t\t\t\t\t\t\t\t\t\t\t//   --border-radius: 50% !important;\n\t\t\t\t\t\t\t\t\t\t\t//   --border-width: 2px !important;\n\t\t\t\t\t\t\t\t\t\t\t//   --border-style: solid !important;\n\t\t\t\t\t\t\t\t\t\t\t//   text-transform: none !important;\n\t\t\t\t\t\t\t\t\t\t\t// }\n\n\t\t\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t\t\t// background: #4A90E2 !important;\n\t\t\t\t\t\t\t\t\t\t\t\t--background: ##2d69aa;\n\t\t\t\t\t\t\t\t\t\t\t\t// color: white !important;\n\t\t\t\t\t\t\t\t\t\t\t\t--color: white;\n\n\t\t\t\t\t\t\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\t\t\t\t\t\t\tcolor: white !important;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t// Hide quantity indicator for cleaner mobile layout\n\t\t\t\t\t\t\t\t\t.amount-in-basket {\n\t\t\t\t\t\t\t\t\t\tdisplay: none !important;\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t// Ensure all text elements are left aligned\n\t\t\t\t\t\t\t\t\th3,\n\t\t\t\t\t\t\t\t\tp {\n\t\t\t\t\t\t\t\t\t\ttext-align: left !important;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.padding-80 {\n\t\t\t\t\theight: 80px;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Fixed notification\n.fixed-notification {\n\tposition: fixed;\n\tbottom: var(--spacing-lg);\n\tleft: 50%;\n\ttransform: translateX(-50%) translateY(100px);\n\tbackground: var(--bg-success);\n\tcolor: white;\n\tpadding: var(--spacing-sm) var(--spacing-lg);\n\tborder-radius: var(--border-radius-pill);\n\tfont-weight: var(--font-weight-medium);\n\tbox-shadow: var(--shadow-lg);\n\topacity: 0;\n\tpointer-events: none;\n\ttransition: all 0.3s ease;\n\tz-index: 1000;\n\n\t&.show-item {\n\t\topacity: 1;\n\t\ttransform: translateX(-50%) translateY(0);\n\t\tpointer-events: auto;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
